import * as yup from 'yup';

export const itemSchema = yup.object({
  sku: yup.string().required(),
  name: yup.string().required(),
  category: yup.string().nullable(),
  unit: yup.string().nullable(),
  minStock: yup.number().min(0).nullable(),
  locations: yup.array().of(yup.string().trim()).nullable(),
});

export const movementSchema = yup.object({
  itemId: yup.string().required('Selecciona un ítem'),
  type: yup.string().oneOf(['IN', 'OUT', 'ADJUST', 'TRANSFER']).required(),
  qty: yup.number().moreThan(0, 'Cantidad > 0').required(),
  fromLocation: yup.string().nullable(),
  toLocation: yup.string().nullable(),
  reason: yup.string().nullable(),
});

export const itemsQuerySchema = yup.object({
  q: yup.string().nullable(),
  category: yup.string().nullable(),
  location: yup.string().nullable(),
  page: yup.number().min(1).nullable(),
});

export const movementsQuerySchema = yup.object({
  itemId: yup.string().nullable(),
  type: yup.string().nullable(),
  from: yup.string().nullable(),
  to: yup.string().nullable(),
  location: yup.string().nullable(),
});

export const stockQuerySchema = yup.object({
  itemId: yup.string().nullable(),
  location: yup.string().nullable(),
});

export const stockSummaryQuerySchema = yup.object({
  category: yup.string().nullable(),
  location: yup.string().nullable(),
});
